"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_EVENT_URL = exports.DELETE_EVENT_URL = exports.CREATE_EVENT_URL = exports.GET_SERIES_EVENTS_URL = exports.PORT = void 0;
exports.PORT = 4001;
exports.GET_SERIES_EVENTS_URL = "/get-series-events";
exports.CREATE_EVENT_URL = "/create-event";
exports.DELETE_EVENT_URL = "/delete-event";
exports.UPDATE_EVENT_URL = "/update-event";
